import { authHeader, handleResponse, handleError } from '../helper';
import APIHelper from "../common/ApiHelper";
import APIURLConstants from "../common/ApiURLConstants";

export const eventCalendarService = {
    readEventsAsync,
    publishCalendarEvent,
    updateCalendarEvent,
    deleteEventsAsync,
    readEventTypesAsync
};

async function readEventsAsync(params) {
    let inputParams = "/"+params;    
    try {
        const response = await APIHelper.get(APIURLConstants.READ_CALENDAR_EVENTS + inputParams, authHeader());
        const data = await handleResponse(response);
        return data;
    } catch (error) {
        return handleError(error);
    }
}

async function deleteEventsAsync(id) {
    let inputParams = "/"+id;
    try {
        const response = await APIHelper.get(APIURLConstants.DELETE_CALENDAR_EVENT + inputParams, authHeader());
        const data = await handleResponse(response);
        return data;
    } catch (error) {
        return handleError(error);
    }
}

async function readEventTypesAsync() {
    try {
        const response = await APIHelper.get(APIURLConstants.READ_CALENDAR_EVENT_TYPES, authHeader());
        const data = await handleResponse(response);
        return data;
    } catch (error) {
        return handleError(error);
    }
}


async function publishCalendarEvent(postData) {
    try {
        const response = await APIHelper.post(APIURLConstants.SAVE_CALENDAR_EVENT, postData, authHeader());
        const data = await handleResponse(response);
        return data;
    } catch (error) {
        return handleError(error);
    }
}


async function updateCalendarEvent(postData) {
    try {
        const response = await APIHelper.post(APIURLConstants.UPDATE_CALENDAR_EVENT, postData, authHeader());
        const data = await handleResponse(response);
        return data;
    } catch (error) {
        return handleError(error);
    }
}
